<script lang="ts" setup>
const name = ref<string>()
const email = ref<string>()
const message = ref<string>()
const checked = ref<boolean>(false)
const errorChecked = ref<boolean>(false)
const hide = ref(false)
const textField = ref()
const loading = ref(false)
const form = ref(null)

const submit = async () => {
	const f = form.value as any
	if (!f.checkValidity()) {
  	f.querySelectorAll(":invalid")[0].focus();
  } else {

		loading.value = true
		const formData = new FormData(f);
		const object:any = {};
		formData.forEach((value, key) => {
			object[key] = value;
		});
		const json = JSON.stringify(object);
		try{
			const response = await fetch("https://api.web3forms.com/submit", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json"
				},
				body: json
			})
			
			if(response.status == 200){
				hide.value = true
			}
		}catch(e){
			console.error('error::',e)
		}

		loading.value = false
	}
}

</script>
<template>
	<div class="mt-4 -mx-4 p-4 rounded-xl transition-all duration-500">
		<div v-if="hide" class="p-10 flex items-center w-full justify-center text-center">
			<svg width="120" height="117" viewBox="0 0 120 117" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M59.0345 117C50.9342 117 42.7939 115.235 35.0548 111.747C24.3482 106.935 15.4461 99.3157 9.23027 89.6917C-0.0329525 75.336 -2.43877 57.5718 2.53344 41.0109C7.38539 24.8906 18.8139 11.8581 33.9318 5.24195C49.9318 -1.77568 69.3803 -0.8932 84.6988 7.56776C86.9443 8.81085 87.7464 11.6179 86.5033 13.8232C85.2602 16.0688 82.4531 16.8708 80.2479 15.6277C67.4159 8.53012 51.0551 7.80823 37.62 13.7029C24.9886 19.2368 15.4046 30.1839 11.3545 43.6974C7.14412 57.6923 9.18909 72.6093 16.9683 84.7194C27.6349 101.281 48.246 110.464 67.0936 107.055C82.0909 104.368 95.4846 94.1428 102.061 80.3485C103.143 78.0628 105.91 77.0603 108.196 78.1831C110.482 79.2658 111.484 82.0327 110.361 84.3182C102.622 100.719 86.6621 112.909 68.7784 116.117C65.5704 116.719 62.3224 117 59.0341 117L59.0345 117Z" fill="#F6743C"/>
				<path d="M54.0226 84.4802C52.8597 84.4802 51.6968 84.0391 50.8146 83.1569L24.5894 57.5732C22.7849 55.8088 22.7448 52.8815 24.5092 51.037C26.2736 49.2325 29.2009 49.1924 31.0454 50.9568L54.0227 73.4127L112.009 16.5927C113.813 14.8283 116.74 14.8283 118.545 16.6729C120.309 18.4774 120.309 21.4046 118.465 23.2092L57.2708 83.1602C56.3886 84.0423 55.2257 84.4835 54.0227 84.4835L54.0226 84.4802Z" fill="#F6743C"/>
			</svg>
		</div>
		<p v-if="!hide" class="font-bold text-4xl font-visby text-black pt-4 pb-6 pl-4">Beta Sign-up</p>
		<!--  -->
		<form v-if="!hide" 
		ref="form"
			@submit.prevent="submit"
			action="https://api.web3forms.com/submit"
      method="POST"
			class="flex flex-col gap-6 needs-validation"
			novalidate
			>

			<!-- Access Key -->
			<input type="hidden" name="access_key" value="6295d60e-ba60-4731-b65a-78e0cd5e3fe5" />

			<!-- Redirect Custom URL -->
			<input type="hidden" name="redirect" value="https://amy-period.app">

			<input
				class="contact-input form-group"
				v-model="name"
				required
				type="text" id="FNAME" name="Name" autocomplete="off" placeholder="Name"  />	
	
			<input
				class="contact-input form-group"
				v-model="email"
				required
				type="email" id="EMAIL" name="email" autocomplete="off" placeholder="Email"  />		

			<input type="hidden" name="subject" value="Bet Sign up" />
			<input type="hidden" name="message" value="Please let me know when the app is released!" />
	
			

		<!-- <div class="flex flex-row gap-x-4 ml-4 items-center">
			<div class="w-6 h-6 relative">
				<input type="checkbox" :class="{'border-red-500 border-2': errorChecked}" 
					class="appearance-none
					checked:bg-green-500/50
					checked:border-green-500
					border
					required:border-red-500 border-white/20 w-6 h-6 bg-transparent rounded-md cursor-pointer" 
					id="OPT_IN" name="OPT_IN" v-model="checked" />
				<svg v-if="checked" class="absolute left-[5px] top-[5px] pointer-events-none" width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M15 4.5L6.75 12.75L3 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
			</div>
			<p class="text-sm text-white/50">Subscribe to our newsletter</p>
		</div> -->
	
		<button v-if="!loading" class="btn-primary mt-4">Submit</button>
		<div v-else role="status" class="h-16">
			<svg aria-hidden="true" class="mx-auto w-8 h-8 text-gray-300 animate-spin dark:text-black/20 fill-black" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
					<path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
			</svg>
			<span class="sr-only">Loading...</span>
		</div>
			
	</form>
</div>
</template>
<style>
.autosize {
  resize: none;
  overflow: hidden;
}
</style>